import React from 'react'
import mainImage from './images/home.jpeg'
import CargoICon from './icons/CargoICon'
import CarIcon from './icons/CarIcon'
import DealIcon from './icons/DealIcon'
import MarketIcon from './icons/MarketIcon'
import { useState ,useEffect} from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { GoChevronDown } from "react-icons/go";
import { GoChevronUp } from "react-icons/go";
import CargoNotif from './images/cargoNotif.png'
import MdLeftDir from './icons/MdLeftDir'
import RecentCargoSection from './modals/RecentCargo'
import ServiceCard from './modals/ServiceCard'
import ChoosCard from './modals/ChoosCard'

import TicketMark from './images/TicketMark.jpeg'
import TickMark from './images/TickMark.jpeg'
import SpeedMark from './images/SpeedMark.jpeg'
import TimeMark from './images/TimeMark.jpeg'


import Footer from '../../components/Footer'

const Home = () => {

    const services = [
        {
          title: "ثبت بار",
          desc: "به سرعت بار خود را ثبت کنید و به شبکه وسیع رانندگان معتبر و متخصص ما دسترسی پیدا کنید تا حمل و نقل شما بدون نگرانی انجام شود.",
          icon: <CargoICon />,
        },
        {
          title: "جست‌وجوی راننده",
          desc: "رانندگان ماهر و معتمد را برای حمل و نقل امن و به موقع بار خود پیدا کنید. سیستم هوشمند ما بهترین تطابق را برای شما می‌یابد.",
          icon: <CarIcon />,
        },
        {
          title: "خرید و فروش و اجاره خودرو",
          desc: "وسیله نقلیه مناسب را برای کسب و کار خود پیدا کنید، آن را به راحتی بخرید یا بفروشید، یا ناوگان خود را اجاره دهید.",
          icon: <DealIcon />,
        },
        {
          title: "فروشگاه",
          desc: "تجهیزات و لوازم یدکی مورد نیاز حمل و نقل را به صورت آنلاین خریداری کنید. بهترین کیفیت و قیمت‌ها را در فروشگاه ما پیدا کنید.",
          icon: <MarketIcon />,
        },
      ];
      const CargoRecent=[
        {
            typeOfCar:"تریلی بغلدار",
            timeOfCargo:"دوشنبه",
            timeOfCreate:"۳ ساعت پیش",
            origin:"اصفهان",
            dest:"تهران"
        },
        {
            typeOfCar:"تریلی بغلدار",
            timeOfCargo:"سه شنبه",
            timeOfCreate:"۴ ساعت پیش",
            origin:"اصفهان",
            dest:"بندر عباس"
        },
        {
            typeOfCar:"تریلی بغلدار",
            timeOfCargo:"پنجشنبه",
            timeOfCreate:"۱۲ ساعت پیش",
            origin:"بندر عباس",
            dest:"تهران"
        },
        {
            typeOfCar:"تریلی بغلدار",
            timeOfCargo:"پنجشنبه",
            timeOfCreate:"۱۲ ساعت پیش",
            origin:"بندر عباس",
            dest:"تهران"
        },
        {
            typeOfCar:"تریلی بغلدار",
            timeOfCargo:"پنجشنبه",
            timeOfCreate:"۱۲ ساعت پیش",
            origin:"بندر عباس",
            dest:"تهران"
        },
        
        
      ]
      const ChoosenCard=[
        {
            title: "صرفه جویی در زمان",
         
            desc: "با بارسرا، زمان کمتری برای پیدا کردن بار و انجام حمل و نقل صرف می‌کنید.",
            icon: <img className='w-20 h-12 object-cover' src={TimeMark}></img> ,
          },
          {
            title: "امنیت کامل",
            desc: "امنیت کامل بار شما با بیمه جامع و نظارت لحظه ای، برای آرامش خاطر شما.",
            icon: <img className='w-20 h-12 object-cover' src={TickMark}></img> ,
          },
          {
            title:"پشتیبانی 24/7",
            desc: "پشتیبانی ۲۴ ساعته در ۷ روز هفته برای حل تمامی مسائل و ارائه بهترین خدمات به شما.",
            icon: <img className='w-20 h-12 object-cover' src={TicketMark}></img> ,
          },
          {
            title:"سرعت بالا",
            desc: "ارسال و دریافت سریع بار با رانندگان با تجربه و شبکه گسترده ما، تضمین تحویل به موقع.",
            icon: <img className='w-20 h-12 object-cover' src={SpeedMark}></img> ,
          },
      ]





  return (
    <>
        <div className="w-full flex flex-col gap-10 min-h-screen  py-10">

                 
                            <div className="flex flex-col mt-6 lg:flex-row items-center shadow-md gap-10 lg:gap-16 bg-white rounded-2xl py-6 lg:py-10 mx-6 lg:mx-20">

                                {/* عکس */}
                                <div className="flex w-full lg:w-1/2 xl:px-20 justify-center">
                                    <img 
                                    src={mainImage} 
                                    alt="بارسرا" 
                                    className="w-full max-w-sm lg:max-w-full rounded-xl object-contain" 
                                    />
                                </div>

                                <div className="flex w-full lg:w-1/2 justify-center lg:justify-start lg:text-start lg:items-start font-YekanBakh">
                                    <div className="flex flex-col items-center    text-center gap-6 w-full">

                                      
                                        <div className="flex flex-col gap-2 w-full" >
                                            <p className="text-[16px] lg:text-[18px] font-light text-special">
                                            حمل و نقل بارهای سنگین را
                                            </p>
                                            <p className="text-[20px] lg:text-[24px] font-bold text-blue-950">
                                            راحت‌تر، هوشمندتر و سریع‌تر
                                            </p>
                                            <p className="text-[16px] lg:text-[18px] font-light text-special">
                                            از همیشه انجام دهید!
                                            </p>
                                        </div>

                                       
                                        <p className="text-[14px] lg:text-[16px] font-YekanBakh font-light text-special leading-relaxed">
                                            اپلیکیشن 
                                            <span className="font-bold text-blue-950 mx-1">بارسرا </span>
                                            همراه مطمئن شما در مسیر باربری است
                                        </p>

                                   
                                        <div className="flex flex-wrap justify-center lg:text-[16px] text-sm   gap-4 w-full">

                                            <button className="min-w-[120px]  h-[40px] border border-special rounded-lg text-special px-4 py-1  bg-gray-100">
                                            دریافت از مایکت
                                            </button>
                                            <button className="min-w-[120px] h-[40px] border border-special rounded-lg text-special px-4 py-1 bg-gray-100">
                                            دریافت از بازار
                                            </button>
                                            <button className="min-w-[120px] h-[40px] border border-special rounded-lg bg-special text-white px-4 py-1 ">
                                            دریافت مستقیم
                                            </button>

                                        </div>

                                    </div>
                                </div>

                            </div>


                        <ServiceCard services={services}></ServiceCard>
                        <RecentCargoSection cargos={CargoRecent}></RecentCargoSection>
                        <ChoosCard services={ChoosenCard}></ChoosCard>
                  

        </div>
        
       <Footer></Footer>
    </>
  )
}




export default Home
